import { render, staticRenderFns } from "./SpyderBrandsWelcomeView.vue?vue&type=template&id=2e702f0d&scoped=true"
import script from "./SpyderBrandsWelcomeView.vue?vue&type=script&lang=js"
export * from "./SpyderBrandsWelcomeView.vue?vue&type=script&lang=js"
import style0 from "./SpyderBrandsWelcomeView.vue?vue&type=style&index=0&id=2e702f0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e702f0d",
  null
  
)

export default component.exports